/** function for generate errors from BE for unlink charging cards from wallboxes */
export const unlinkTokensApiErrors: Record<string, string> = {
  BAD_REQUEST: 'emobility.api-errors.bad-request',
  INVALID_OR_MISSING_CREDENTIALS: 'emobility.api-errors.invalid-credentials',
  LACK_OF_PERMISSIONS: 'emobility.api-errors.lack-permissions',
  ACCOUNT_LINK_NOT_FOUND: 'emobility.api-errors.account-no-found',
  INSTALLATION_NOT_FOUND: 'emobility.api-errors.installation-no-found',
}
